import { Box } from '@chakra-ui/react';
import { useFormContext, useWatch } from 'react-hook-form';

import { BasicTextEditor } from 'shared';

import {
  SessionSidebarFieldset,
  SessionSidebarFieldsetLabel,
} from 'features/sessions/components';

import { TextEditorFormats } from 'shared/components/TextEditor/constants';

const NEXT_SESSION_NOTES_FIELD_KEY = 'nextSessionNotes';

export const NextSessionNotes = () => {
  const { setValue } = useFormContext();

  const notesValue = useWatch({ name: NEXT_SESSION_NOTES_FIELD_KEY }) ?? '';

  const handleChange = (value: string) => {
    setValue(NEXT_SESSION_NOTES_FIELD_KEY, value, {
      shouldDirty: true,
    });
  };

  return (
    <SessionSidebarFieldset dataTestid="sidebar-next-session-notes">
      <SessionSidebarFieldsetLabel>
        Next session notes
      </SessionSidebarFieldsetLabel>
      <Box h="12rem">
        <BasicTextEditor
          value={notesValue}
          onChange={handleChange}
          placeholder="Start writing here"
          format={TextEditorFormats.json}
        />
      </Box>
    </SessionSidebarFieldset>
  );
};
